export default __webpack_public_path__ + "static/media/con_MOVG02.45983184.jpg";